/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fetchAPI, URL_API } from "api";
import { FilterOptions, QueryBuilder, QueryBuilderOptions } from "utils/builderUtils";

const ROTA = '/forms/cifa';

class CifaAPI {
    static async getByInstitutionAndYear(institution_uuid: string, year: number) {
        const response = await fetchAPI(`${URL_API}${ROTA}/${year}/${institution_uuid}`, 'GET', null);
        return response;
    }

    static async listarCifas(year: number, options?: QueryBuilderOptions) {
        const filters: FilterOptions[] = [
            { field: 'ano_referencia', operator: '$eq', value: year },
            ...(options?.filters || [])
        ];

        const queryParams = QueryBuilder({
            page: options?.page,
            limit: options?.limit,
            search: options?.search,
            filters,
            sortBy: options?.sortBy
        });

        const response = await fetchAPI(`${URL_API}${ROTA}/listagem-cifa?${queryParams}`, 'GET', null);
        return response;
    }

    static async updateCumprimentoDoTermoEscolar(institution_uuid: string, data: any) {
        const response = await fetchAPI(`${URL_API}${ROTA}/cumprimento-do-termo-escolar/${institution_uuid}`, 'POST', data);
        return response;
    }

    static async updateSchoolFeeding(institution_uuid: string, data: any) {
        const response = await fetchAPI(`${URL_API}${ROTA}/alimentacao-escolar/${institution_uuid}`, 'POST', data);
        return response;
    }

    static async createSchoolFeedingAcquisitions(institution_uuid: string, data: any) {
        const response = await fetchAPI(`${URL_API}${ROTA}/alimentacao-escolar-aquisicao/${institution_uuid}`, 'POST', data);
        return response;
    }

    static async updateSchoolFeedingAcquisitions(institution_uuid: string, data: any) {
        const response = await fetchAPI(`${URL_API}${ROTA}/alimentacao-escolar-aquisicao/${institution_uuid}`, 'PUT', data);
        return response;
    }

    static async createFinancialResource(institution_uuid: string, data: any) {
        const response = await fetchAPI(`${URL_API}${ROTA}/recursos-financeiros-aplicados/${institution_uuid}`, 'POST', data);
        return response;
    }

    static async updateFinancialResource(institution_uuid: string, data: any) {
        const response = await fetchAPI(`${URL_API}${ROTA}/recursos-financeiros-aplicados/${institution_uuid}`, 'PUT', data);
        return response;
    }

    static async getListCifas(year: number) {
        const response = await fetchAPI(`${URL_API}${ROTA}/list-by-year/${year}`, 'GET', null);
        return response;
    }

    static async createTechAssist(cifa_uuid: string, data: any) {
        const response = await fetchAPI(`${URL_API}${ROTA}/assistencia-tecnica/${cifa_uuid}`, 'POST', data);
        return response;
    }

    static async updateTechAssist(cifa_uuid: string, data: any) {
        const response = await fetchAPI(`${URL_API}${ROTA}/assistencia-tecnica/${cifa_uuid}`, 'PUT', data);
        return response;
    }

    static async sendToApproval(cifa_uuid: string) {
        const response = await fetchAPI(`${URL_API}${ROTA}/send-to-approval/${cifa_uuid}`, 'POST', null);
        return response;
    }
}



export default CifaAPI;